/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StartMatchResult interface.
 */
export function instanceOfStartMatchResult(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('matchId' in value) || value['matchId'] === undefined)
        return false;
    return true;
}
export function StartMatchResultFromJSON(json) {
    return StartMatchResultFromJSONTyped(json, false);
}
export function StartMatchResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'matchId': json['matchId'],
    };
}
export function StartMatchResultToJSON(json) {
    return StartMatchResultToJSONTyped(json, false);
}
export function StartMatchResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'matchId': value['matchId'],
    };
}
